const hasValue = value => value !== null && value !== undefined && value !== "";

export {
    hasValue
}